import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#595556",
      d: "m10 14.356-4-1.4-2.87 1.11a.55.55 0 0 1-.545-.065.57.57 0 0 1-.252-.49V4.766a.6.6 0 0 1 .106-.355q.106-.157.297-.228L6 3.074l4 1.4 2.87-1.11a.56.56 0 0 1 .545.056.54.54 0 0 1 .252.475v8.795a.58.58 0 0 1-.116.357.66.66 0 0 1-.312.225zm-.5-1.223v-7.8l-3-1.049v7.8zm1 0 2.167-.718v-7.9l-2.167.818zm-7.167-.218 2.167-.83v-7.8l-2.167.73z"
    }, null, -1)
  ])))
}
export default { render: render }